var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: { handler: "hideResults" },
          expression: "{ handler: 'hideResults' }",
        },
      ],
      ref: "container",
      class: [_vm.$style["mds-combo-box"], _vm.classObject, _vm.sizeClass],
      attrs: { disabled: _vm.disabled },
    },
    [
      _c(
        "div",
        {
          ref: "wrapper",
          class: _vm.$style["mds-combo-box__multiple-select"],
          attrs: {
            "aria-describedby": _vm.ariaDescription,
            "aria-disabled": _vm.disabled ? "true" : null,
            tabindex: !_vm.disabled ? "0" : null,
          },
        },
        [
          _c("mds-icon", {
            class: _vm.$style["mds-combo-box__open-icon"],
            attrs: { name: _vm.iconName, size: "small", role: "presentation" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "selection",
              class: [
                _vm.$style["mds-combo-box__selected-list"],
                _vm.focusClass,
              ],
              attrs: { "aria-labelledby": _vm.ariaLabel },
            },
            [
              !_vm.showResults &&
              _vm.searchTerm.length === 0 &&
              _vm.selectedItems.length === 0
                ? _c(
                    "span",
                    { class: _vm.$style["mds-combo-box__placeholder"] },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.placeholder) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.selectedItems, function (item, index) {
                return _c("mds-tag", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedItems.length < _vm.multipleItemLimit,
                      expression: "selectedItems.length < multipleItemLimit",
                    },
                  ],
                  key: index,
                  class: _vm.$style["mds-combo-box__selection-tag"],
                  attrs: {
                    id: _vm.tagId(),
                    "data-text": item.text,
                    "data-value": item.value,
                    text: item.text,
                    removable: _vm.disabled ? null : true,
                    "on-light": !_vm.onDark,
                    "on-dark": _vm.onDark,
                    size: _vm.tagSize,
                    "remove-icon-aria-label": "Remove",
                  },
                  on: {
                    "mds-tag-removed": function ($event) {
                      return _vm.handleRemoveClick(item.value)
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c("mds-tag", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedItems.length >= _vm.multipleItemLimit,
                    expression: "selectedItems.length >= multipleItemLimit",
                  },
                ],
                class: _vm.$style["mds-combo-box__selection-tag"],
                attrs: {
                  id: _vm.tagId(),
                  text: _vm.selectedItems.length + " Items selected",
                  removable: _vm.disabled ? null : true,
                  "on-light": !_vm.onDark,
                  "on-dark": _vm.onDark,
                  "remove-icon-aria-label": "Remove",
                  size: _vm.tagSize,
                },
                on: {
                  "mds-tag-removed": function ($event) {
                    return _vm.handleRemoveClick()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$style["mds-combo-box__assistive-message"] },
                [
                  _vm.showResults && _vm.filteredList.length === 0
                    ? _c("span", { attrs: { "aria-live": "assertive" } }, [
                        _vm._v(_vm._s(_vm.noResultsLabel)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showResults && _vm.filteredList.length > 0
                    ? _c(
                        "span",
                        {
                          attrs: {
                            role: "status",
                            "aria-atomic": "true",
                            "aria-live": "polite",
                          },
                        },
                        [
                          _vm._t(
                            "mds-combo-box-result-description",
                            function () {
                              return [
                                _vm._v(
                                  _vm._s(_vm.filteredList.length) +
                                    " results are available. Use up and down arrows to review and enter\n                        to select options."
                                ),
                              ]
                            },
                            { itemsCount: _vm.filteredList.length }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedItems.length > 0
                    ? _c(
                        "span",
                        { attrs: { "aria-live": "polite" } },
                        [
                          _vm._t(
                            "mds-combo-box-selection-description",
                            function () {
                              return [
                                _vm._v(
                                  "Multi selection combo box. " +
                                    _vm._s(_vm.selectedItems.length) +
                                    " selected items:\n                        " +
                                    _vm._s(_vm.selectedItemsInfo) +
                                    ". Use Tab to remove items or search for more items."
                                ),
                              ]
                            },
                            {
                              selectedCount: _vm.selectedItems.length,
                              selectedItems: _vm.selectedItemsInfo,
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "input",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchTerm,
                          expression: "searchTerm",
                        },
                      ],
                      ref: "input",
                      class: _vm.$style["mds-combo-box__input"],
                      attrs: {
                        type: "text",
                        disabled: _vm.disabled,
                        id: _vm.ariaInputId,
                        role: "combobox",
                        "aria-haspopup": "listbox",
                        "aria-autocomplete": "list",
                        autocomplete: "off",
                        "aria-controls": _vm.resultsId,
                        "aria-activedescendant": _vm.ariaActiveDescendant,
                        required: _vm.required,
                        "aria-expanded": _vm.showResults ? "true" : "false",
                      },
                      domProps: { value: _vm.searchTerm },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.searchTerm = $event.target.value
                          },
                          _vm.handleInput,
                        ],
                        focus: _vm.setFocus,
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "delete",
                                [8, 46],
                                $event.key,
                                ["Backspace", "Delete", "Del"]
                              )
                            )
                              return null
                            return _vm.deleteTags.apply(null, arguments)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "arrow-down",
                                undefined,
                                $event.key,
                                undefined
                              )
                            )
                              return null
                            return _vm.openResults()
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "tab",
                                9,
                                $event.key,
                                "Tab"
                              )
                            )
                              return null
                            return _vm.handleTab.apply(null, arguments)
                          },
                        ],
                        click: function ($event) {
                          return _vm.toggleResults()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          if ($event.target !== $event.currentTarget)
                            return null
                          $event.preventDefault()
                          return _vm.openResults()
                        },
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.userListeners
                )
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showResults,
                  expression: "showResults",
                },
              ],
            },
            [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "auto-direction",
                      rawName: "v-auto-direction",
                      value: _vm.positionResults,
                      expression: "positionResults",
                    },
                    {
                      name: "keyboard-navigation",
                      rawName: "v-keyboard-navigation",
                      value: _vm.handleKeyboardNavigation,
                      expression: "handleKeyboardNavigation",
                    },
                  ],
                  ref: "results",
                  class: _vm.$style["mds-combo-box__result-list"],
                  attrs: { role: "listbox", id: _vm.resultsId },
                },
                [
                  _vm._l(_vm.filteredList, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        ref: index,
                        refInFor: true,
                        class: {
                          [_vm.$style["mds-combo-box__item-selected"]]:
                            _vm.isSelected(item.value),
                          [_vm.$style["mds-combo-box--highlighted"]]:
                            _vm.isHighlighted(item, index),
                          [_vm.$style["mds-combo-box--heading"]]:
                            item.value === null,
                          [_vm.$style["mds-combo-box--child"]]:
                            item.child === true,
                        },
                        attrs: {
                          role: "option",
                          id: `mds-combo-box__descendent-${_vm.resultsId}--${index}`,
                          "aria-posinset": index + 1,
                          "aria-setsize": _vm.filteredList.length,
                          "aria-selected": _vm.isHighlighted(item, index)
                            ? "true"
                            : "false",
                          "data-text": item.text,
                          "data-value": item.value,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.setItemState(item.text, item.value)
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm.highlightCharacters(
                              item.text,
                              _vm.searchTerm,
                              _vm.$style
                            ),
                          },
                        }),
                        _vm._v(" "),
                        item.metadata
                          ? _c(
                              "div",
                              {
                                class:
                                  _vm.$style["mds-combo-box__item-metadata"],
                              },
                              _vm._l(item.metadata, function (item, index) {
                                return _c("span", {
                                  key: `metabelow-${index}`,
                                  class: [
                                    _vm.$style[
                                      "mds-combo-box__item-metadata-item"
                                    ],
                                  ],
                                  domProps: { innerHTML: _vm._s(item) },
                                })
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSelected(item.value)
                          ? _c("mds-icon", {
                              class: _vm.$style["mds-combo-box__selected-icon"],
                              attrs: {
                                name: "check",
                                size: "small",
                                role: "presentation",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.filteredList.length === 0,
                          expression: "filteredList.length === 0",
                        },
                      ],
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.noResultsLabel))]
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }